"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var operators_1 = require("rxjs/operators");
var idm_kb_service_client_js_1 = require("@synisys/idm-kb-service-client-js");
var page_component_1 = require("./page.component");
var Subject_1 = require("rxjs/Subject");
var zip_1 = require("rxjs/observable/zip");
var of_1 = require("rxjs/observable/of");
/**
 * Form component, which extends PageAbstractComponent class.
 * It contains common properties and methods for edit components.
 */
var FormComponent = /** @class */ (function (_super) {
    __extends(FormComponent, _super);
    /**
     * The default constructor.
     */
    function FormComponent(_deService, _classifierService, _kbService, _languageService, _currentLanguageProvider) {
        var _this = _super.call(this) || this;
        _this._deService = _deService;
        _this._classifierService = _classifierService;
        _this._kbService = _kbService;
        _this._languageService = _languageService;
        _this._currentLanguageProvider = _currentLanguageProvider;
        /**
         * This flag shows if the page is ready for rendering.
         * To be ready it is necessary to preload all the used Classifier Lists, Current language and Case Model.
         * @type {boolean}
         */
        _this.isReady = false;
        /**
         * Array of project languages.
         * @type {Array<Language>}
         * @private
         */
        _this._languages = null;
        /**
         * Selected language ID.
         * @type {number}
         * @private
         */
        _this._currentLanguageId = null;
        /**
         * Validations for model. This validations are filled when the model is sent to server for saving.
         * @type {Array}
         * @private
         */
        _this._validations = [];
        /**
         * Component system name
         * @type {string}
         * @private
         */
        _this._systemName = null;
        /**
         * Component model.
         * @type {MainEntity}
         * @protected
         */
        _this._mainEntity = null;
        /**
         * Component old model.
         * @type {MainEntity}
         * @protected
         */
        _this._oldMainEntity = null;
        /**
         * Workflow state system name.
         * @type {string}
         * @protected
         */
        _this._workflowStateFieldName = null;
        /**
         * Subject for storing notification status
         */
        _this._notificationStatus = new Subject_1.Subject();
        /**
         * ID of new Entity.
         * @type {number}
         * @private
         */
        _this.newEntityId = -1;
        _this._classifierItems = new Map();
        return _this;
    }
    Object.defineProperty(FormComponent.prototype, "systemName", {
        get: function () {
            return this._systemName;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(FormComponent.prototype, "mainEntity", {
        get: function () {
            return this._mainEntity;
        },
        set: function (value) {
            this._mainEntity = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(FormComponent.prototype, "oldMainEntity", {
        get: function () {
            return this._oldMainEntity;
        },
        set: function (value) {
            this._oldMainEntity = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(FormComponent.prototype, "classifierItems", {
        get: function () {
            return this._classifierItems;
        },
        set: function (classifierItems) {
            this._classifierItems = classifierItems;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(FormComponent.prototype, "hasWorkflow", {
        get: function () {
            return this._hasWorkflow;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(FormComponent.prototype, "languages", {
        get: function () {
            return this._languages;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(FormComponent.prototype, "currentLanguageId", {
        get: function () {
            return this._currentLanguageId;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(FormComponent.prototype, "validations", {
        get: function () {
            return this._validations;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(FormComponent.prototype, "workflowStateFieldName", {
        get: function () {
            return this._workflowStateFieldName;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(FormComponent.prototype, "notificationStatus", {
        get: function () {
            return this._notificationStatus;
        },
        set: function (value) {
            this._notificationStatus = value;
        },
        enumerable: true,
        configurable: true
    });
    FormComponent.prototype.getValidation = function (fieldSystemName) {
        for (var _i = 0, _a = this._validations; _i < _a.length; _i++) {
            var validation = _a[_i];
            var relatedFields = validation.getRelatedMetaFieldIds();
            for (var _b = 0, relatedFields_1 = relatedFields; _b < relatedFields_1.length; _b++) {
                var relatedMetaFieldId = relatedFields_1[_b];
                if (relatedMetaFieldId.getSystemName() === fieldSystemName) {
                    return validation;
                }
            }
        }
        return null;
    };
    /**
     * Loads mainEntity with the given Instance Id.
     * @param {number} instanceId - InstanceId of the saved mainEntity.
     * @protected
     */
    FormComponent.prototype.loadMainEntity = function (instanceId) {
        var _this = this;
        return this._deService
            .loadEntityByInstanceId(this._systemName, instanceId)
            .pipe(operators_1.switchMap(function (mainEntity) {
            _this._mainEntity = mainEntity;
            _this._oldMainEntity = _this._mainEntity.clone();
            return _this.onMainEntityLoaded();
        }));
    };
    /**
     * Preparation after MainEntity load
     * @returns {Observable<any>}
     */
    FormComponent.prototype.onMainEntityLoaded = function () {
        return zip_1.zip(this._loadClassifiers(), this.loadWorkflowExistence());
    };
    /**
     * Classifiers Load for used Classifiers in mainEntity and zipping
     * @returns {Observable<R>|Observable<T[]>}
     * @private
     */
    FormComponent.prototype._loadClassifiers = function () {
        var _this = this;
        var formClassifiers = this.getFormClassifiers();
        if (formClassifiers !== null) {
            var observables_1 = [];
            formClassifiers.forEach(function (value, key) {
                observables_1.push(_this._loadClassifier(key, value));
            });
            return zip_1.zip.apply(void 0, observables_1);
        }
        else {
            return of_1.of([]);
        }
    };
    /**
     * Classifier Name Mapping by system names as Key and local Name as Value
     * @returns {Map<string, string>}
     */
    FormComponent.prototype.getFormClassifiers = function () {
        return null;
    };
    /**
     * Loads classifier to entity's classifierItems property.
     * @param {string} systemName - Category name of the required classifier.
     * @param {string} classifierKey - Classifier key of the entity.
     * @param {number} parentId - The parentId to filter entries by.
     */
    FormComponent.prototype._loadClassifier = function (systemName, classifierKey, parentId) {
        var _this = this;
        if (parentId !== null && parentId !== undefined) {
            return this._classifierService
                .loadClassifiersViewByParent(systemName, parentId)
                .pipe(operators_1.map(function (_classifiersData) {
                _this._classifierItems.set(classifierKey, _classifiersData);
                return _classifiersData;
            }));
        }
        else {
            return this._classifierService.loadClassifiersView(systemName).pipe(operators_1.map(function (_classifiersData) {
                _this._classifierItems.set(classifierKey, _classifiersData);
                return _classifiersData;
            }));
        }
    };
    /**
     * Returns classifier by selected classifier id.
     * @param {number} classifierId - Classifier id, which is selected.
     * @param {string} classifierKey - Classifier key of the household.
     * @returns {Classifier}
     */
    FormComponent.prototype.getClassifierById = function (classifierId, classifierKey) {
        var classifiers = this._classifierItems.get(classifierKey);
        return classifiers.find(function (classifier) {
            return classifier.getId() === classifierId;
        });
    };
    /**
     * Gives the successive negative ID per Entity.
     * @returns {number}
     */
    FormComponent.prototype.getNewEntityId = function () {
        return this.newEntityId--;
    };
    /**
     * Method for checking the availability of Workflow for the mainEntity (main category)
     * @returns {boolean}
     */
    FormComponent.prototype.loadWorkflowExistence = function () {
        var _this = this;
        return this._kbService.getMetaFields(this._systemName).pipe(operators_1.switchMap(function (metaFields) {
            _this._hasWorkflow = false;
            for (var _i = 0, metaFields_1 = metaFields; _i < metaFields_1.length; _i++) {
                var metaField = metaFields_1[_i];
                if (metaField.getType() === idm_kb_service_client_js_1.MetaFieldType.WORKFLOW_STATE) {
                    _this._hasWorkflow = true;
                    break;
                }
            }
            return _this.onWorkflowExistenceLoaded();
        }));
    };
    return FormComponent;
}(page_component_1.PageComponent));
exports.FormComponent = FormComponent;
//# sourceMappingURL=form.component.js.map